import { render, staticRenderFns } from "./TheToolbar.vue?vue&type=template&id=54abbbd0&scoped=true"
import script from "./TheToolbar.vue?vue&type=script&lang=js"
export * from "./TheToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheToolbar.vue?vue&type=style&index=0&id=54abbbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abbbd0",
  null
  
)

export default component.exports